import { render } from "./finalReport.vue?vue&type=template&id=36ee30f7&scoped=true"
import script from "./finalReport.js?vue&type=script&lang=js"
export * from "./finalReport.js?vue&type=script&lang=js"

import "./finalReport.vue?vue&type=style&index=0&id=36ee30f7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ee30f7"]])

export default __exports__